import { Pagination } from "react-admin";

const CustomPagination = () => (
  <Pagination rowsPerPageOptions={[50, 100, 500]} />
);
export default CustomPagination;
